import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ToasterService } from '@abp/ng.theme.shared';
import { DocTemplateDto, DocTemplateService } from '@digiwall/goliath-documents/proxy';
import {
  LanguageStore,
  BaseDetailPage,
  DeactivatableComponentService,
  ShortcutKey,
  DwDetailHeaderComponent,
} from '@digiwall/core';
import { GoliathCoreEnumerationTypeStore } from '@digiwall/goliath-core';
import { PanelComponent } from '@digiwall/ui-kit';
import { DwGridDetailNavigationComponent, DwTabsComponent } from '@digiwall/ag-grid';
import {
  NgbNav,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavContent,
  NgbScrollSpy,
  NgbScrollSpyFragment,
  NgbNavOutlet,
} from '@ng-bootstrap/ng-bootstrap';
import { DwNavLinkDirective } from '@digiwall/core';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { ErrorFormControlDirective } from '@digiwall/core';
import { DwInputRequiredDirective } from '@digiwall/core';
import { DwInputDirective } from '@digiwall/core';
import { NgSelectComponent, NgMultiLabelTemplateDirective } from '@ng-select/ng-select';
import { AutoSizedDropdownDirective } from '@digiwall/ui-kit';
import { DwScrollSpyDirective } from '@digiwall/ag-grid';
import { DocTemplateLinesEditorComponent } from './doc-template-lines/doc-template-lines-editor.component';
import { SidePanelComponent } from '@digiwall/ui-kit';
import { GoliathDocumentEntityNames } from '../../../constants/entity-names.constants';

@Component({
  selector: 'document-doc-template-detail',
  templateUrl: './doc-template-detail.component.html',
  imports: [
    CommonModule,
    PanelComponent,
    DwTabsComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    DwNavLinkDirective,
    NgbNavContent,
    NgbScrollSpy,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    ErrorFormControlDirective,
    DwInputRequiredDirective,
    DwInputDirective,
    NgSelectComponent,
    AutoSizedDropdownDirective,
    NgMultiLabelTemplateDirective,
    NgbScrollSpyFragment,
    DwScrollSpyDirective,
    DocTemplateLinesEditorComponent,
    NgbNavOutlet,
    SidePanelComponent,
    FormsModule,
    LocalizationModule,
    DwGridDetailNavigationComponent,
    DwDetailHeaderComponent,
  ],
})
export class DocTemplateDetailComponent
  extends BaseDetailPage<DocTemplateDto, DocTemplateService>
  implements OnInit
{
  form: FormGroup;

  shortcut = ShortcutKey;

  enumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  coreEnumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);
  languageStore = inject(LanguageStore);

  protected GoliathDocumentEntityNames = GoliathDocumentEntityNames;

  constructor(
    protected route: ActivatedRoute,
    protected formBuilder: FormBuilder,
    protected subscriptionService: SubscriptionService,
    protected docTemplateService: DocTemplateService,
    protected breadcrumbService: BreadcrumbService,
    protected localizationService: LocalizationService,
    protected toasterService: ToasterService,
    protected router: Router,
    protected deactivatableComponentService: DeactivatableComponentService,
  ) {
    super(route, deactivatableComponentService, docTemplateService);
  }

  protected initForm() {
    this.form = this.formBuilder.group({
      uniqueCode: [null, Validators.required],
      isActive: [true, Validators.required],
      name: ['', Validators.required],
      languageId: [null, Validators.required],
      roles: [[]],
    });
  }

  protected initBreadcrumb(): void {
    this.breadcrumbService.set(
      '@entityName',
      this.entity?.uniqueCode ?? this.localizationService.instant(`::Add`),
    );
  }

  public updateNote(event: Event) {
    this.docTemplateService
      .updateNote(this.entity.id, (event.target as HTMLTextAreaElement).value)
      .subscribe(data => {
        this.entity = data;
      });
  }

  activateSaveButton() {
    this.form.markAsDirty();
  }
}
